module.exports = __webpack_public_path__ + "images/lancia_smallb1d5e3641ae92fc2978e0b0b8b29689c.png";